import React, { useEffect, useState } from "react";
import styles from "./skills.module.scss";
import RadialPieChart from "../../radialPieChart";
import { useSelector } from "react-redux";

import cx from "classnames";
import _ from "lodash";
import LinesEllipsis from "react-lines-ellipsis";
import Text from "src/components/text";

const SkillsReport = () => {
  const loading = useSelector((state: any) =>
    _.get(state.coaching, "reports.teams.skills.loading", false),
  );
  const skills = useSelector((state: any) =>
    _.get(state.coaching, "reports.teams.skills.items", []),
  );

  const [pieData, setPieData] = useState<{ name: string; value: number; color: string }[]>([]);

  const colors = [
    "#F25757",
    "#F27D7D",
    "#F2B3B3",
    "#555555",
    "#888888",
    "#CCCCCC",
    "#57F257",
    "#7DF27D",
    "#B3F2B3",
    "#5757F2",
  ];

  useEffect(() => {
    const items = skills.map((item, index) => {
      return {
        name: item.name,
        value: item.percentage,
        color: colors[index % colors.length],
      } as { name: string; value: number; color: string };
    });

    setPieData(items);
  }, [skills]);

  if(_.size(skills) === 0 && !loading) {
    return <></>
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>skills acquired by the team</div>

      {loading && <PlaceholderSkill />}
      {!loading && (
        <div className={styles.wrapper}>
          <RadialPieChart data={pieData} />
          <div className={styles.skills}>
            {pieData.map((item, index) => (
              <div className={styles.skill} key={index}>
                <div className={styles.skillName}>
                  <span
                    className={cx(styles.icon)}
                    style={{ backgroundColor: item.color}}
                  />
                  <Text
                    className={styles.name}
                    text={item.name || "" }
                    lines={1}
                  />
                </div>
                <span className={styles.percentage}>
                  {Math.round(item.value)}%
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillsReport;

const PlaceholderSkill: React.FC<object> = () => {
  return (
    <div className={cx(styles.wrapper, styles.placeholder)}>
      <div className={cx(styles.skills, styles.placeholder)}>
        <div className={cx(styles.circle)} />
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>

        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>

        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>

        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
        <div className={styles.skill}>
          <div className={cx(styles.skillName)}>
            <div className={cx(styles.icon, styles.block)} />
            <span className={cx(styles.name, styles.block)} />
          </div>
          <span className={cx(styles.percentage, styles.block)} />
        </div>
      </div>
    </div>
  );
};
